export const getActivityTypes = (state) => state.types
export const getActivityIcons = (state) => state.icons
